import { Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { GridConnectService } from '../grid-connect.service';
import { interval, Subject, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'qpoint-grid-sticky-chooser',
  templateUrl: './grid-sticky-chooser.component.html',
  styleUrls: ['./grid-sticky-chooser.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true
})
export class QPointGridStickyChooserComponent implements OnInit, OnDestroy {

  private chooserFound = new Subject<void>();
  private columnChooser;

    private ngUnsubscribe = new Subject<void>();

  constructor(private gridService: GridConnectService, private hostReference: ElementRef, private renderer2: Renderer2) {
  }

  public toggle() {
    timer(1).subscribe(value => {
      this.gridService.openChooserMenu();
    });

  }
  ngOnInit(): void {
    interval(100).pipe(takeUntil(this.chooserFound)).subscribe(value => {
      const columnChooserFromGrid = this.gridService?.columnChooserComponent();
      if (columnChooserFromGrid) {
        this.stickChooserToComponent(columnChooserFromGrid);
        this.columnChooser = columnChooserFromGrid;
        this.chooserFound.next();
      }
    });
  }


  private stickChooserToComponent(columnChooser: ElementRef) {
    this.renderer2.setStyle(columnChooser.nativeElement, 'display', 'block');
    this.renderer2.setStyle(columnChooser.nativeElement, 'height', '0');
    this.renderer2.setStyle(columnChooser.nativeElement, 'margin-top', '-15px');

    this.renderer2.appendChild(this.hostReference.nativeElement, columnChooser.nativeElement);
  }

  ngOnDestroy(): void {
    if (this.hostReference.nativeElement && this.columnChooser) {
      this.renderer2.removeChild(this.hostReference.nativeElement, this.columnChooser);
    }
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
